import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle_edit",
  "use": "circle_edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle_edit\">\n<path d=\"M6 12.7294V14.5H7.77059L12.8706 9.47059L11.1 7.7L6 12.7294ZM14.3619 7.90869C14.546 7.72455 14.546 7.42709 14.3619 7.24295L13.257 6.13811C13.0729 5.95396 12.7754 5.95396 12.5913 6.13811L11.7273 7.00215L13.4978 8.77274L14.3619 7.90869Z\" fill=\"#616161\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"9.5\" stroke=\"#616161\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol